// extracted by mini-css-extract-plugin
export default {"textTitle":"NavFooter_textTitle__uWeOb","containerContent":"NavFooter_containerContent__luXH1"};